import { settings, useSetting } from '../../../../settings';

export function useProjectControllingColumnSettings(category: string) {
  const settingPlanned = useSetting(
    settings.projectControllingcalPlannedColumns()
  );
  const settingActual = useSetting(
    settings.projectControllingcalActualColumns()
  );
  const settingComparison = useSetting(
    settings.projectControllingcalComparisonColumns()
  );
  const settingPlannedTimes = useSetting(
    settings.projectControllingcalPlannedTimesColumns()
  );

  const settingTargetContributionMargin = useSetting(
    settings.projectControllingTargetContributionMarginColumns()
  );

  const settingsMap = {
    planned: settingPlanned,
    actual: settingActual,
    comparison: settingComparison,
    plannedTimes: settingPlannedTimes,
    targetContributionMargin: settingTargetContributionMargin,
  };

  return settingsMap[category];
}
